export const useStyles = (theme) => ({
  root: {
    paddingLeft: 90,
    paddingRight: 90,
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
  },
  paper: {
    padding: 30,
  },
  title: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  nameinputStyle: {
    outline: "none",
    width: "32%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  inputRoot: {
    height: 70,
  },
  labelRoot: {
    fontSize: 18,
    fontWeight: "bolder",
  },
  notchedOutline: {},
  labelFocused: { color: "black !important" },
  focused: {
    "& $notchedOutline": {
      borderColor: "black !important",
    },
  },
  errorStyle: {
    color: "red",
  },
  buttonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 20,
  },
});
